import { shallowEqual } from "react-redux";
import {
  selectAllYears,
  selectTourFilterOptions,
  selectStageFilterOptions,
} from "selectors/Tour";
import {
  selectTournamentFilterOptionsFromFilters,
  selectTournamentFilterOptionsFromTrackId,
  selectTournamentSegmentFilterOptions,
} from "selectors/Tournament";
import { useFilter, useMultiFilter } from "./Filters";
import { useAppSelector } from "app/hooks";

// todo - create generic that takes a selector??
// todo - extract the adding of "All" to generic useFilter
export const useYearFilter = (allOption: boolean = false) => {
  const years = useAppSelector(selectAllYears).map((y) => y.toString());
  const yearOptions = allOption ? ["All", ...years] : years;
  return useFilter(yearOptions, allOption ? "All" : "2025");
};

export const useTourFilter = (
  year: string,
  initialValue?: string,
  includeNonTourTournaments: boolean = false,
  allOption: boolean = false
) => {
  const tourOptions = useAppSelector(
    (state) => selectTourFilterOptions(state, year, includeNonTourTournaments),
    shallowEqual
  );
  return useFilter(
    allOption ? ["All", ...tourOptions] : tourOptions,
    initialValue
  );
};

export const useSubTourFilter = (
  tourName: string | undefined,
  initialValue?: string,
  allOption: boolean = false
) => {
  const stageOptions =
    useAppSelector(
      (state) => selectStageFilterOptions(state, tourName),
      shallowEqual
    ) ?? [];
  return useFilter(
    allOption ? ["All", ...stageOptions] : stageOptions,
    initialValue
  );
};

export const useMultiSubTourFilter = (tourName: string | undefined) => {
  const stageOptions =
    useAppSelector(
      (state) => selectStageFilterOptions(state, tourName),
      shallowEqual
    ) ?? [];

  return useMultiFilter(stageOptions);
};

export const useMultiTournamentFilter = (
  year: string,
  tourOrTournamentName: string | undefined,
  subTourName: string | undefined,
  includeNonTourTournaments: boolean = false
) => {
  const options = useAppSelector(
    (state) =>
      selectTournamentFilterOptionsFromFilters(
        state,
        year,
        tourOrTournamentName,
        !!subTourName ? [subTourName] : undefined,
        includeNonTourTournaments
      ),
    shallowEqual
  );

  return useMultiFilter(options);
};

export const useMultiTournamentFilterFromTrackId = (
  trackId: string | undefined
) => {
  const options = useAppSelector(
    (state) => selectTournamentFilterOptionsFromTrackId(state, trackId),
    shallowEqual
  );

  return useMultiFilter(options);
};

export const useMultiSegmentFilter = (tournamentId: string) => {
  const options =
    useAppSelector(
      (state) => selectTournamentSegmentFilterOptions(state, tournamentId),
      shallowEqual
    ) ?? [];

  return useMultiFilter(options);
};
